// loginStatus.js
import React, { useState, useEffect, useRef } from "react";
import "./loginStatus.css";

const TYPE_SPEED = 55;

const LoginStatus = ({ message = "Awaiting Login...", active = false, className = "" }) => {
    const [displayed, setDisplayed] = useState("");
    const [isTyping, setIsTyping] = useState(true); // start as true for initial type
    const lastMsg = useRef(""); // keep track of last message

    useEffect(() => {
        // Always restart typing effect if the message changes
        setDisplayed("");
        setIsTyping(true);
        lastMsg.current = message;
        let i = 0;
        const interval = setInterval(() => {
            setDisplayed(message.slice(0, i + 1));
            i++;
            if (i === message.length) {
                clearInterval(interval);
                setIsTyping(false);
            }
        }, TYPE_SPEED);
        return () => clearInterval(interval);
    }, [message]);

    return (
        <div className={`login-status${active ? " active" : ""} ${className}`}>
            {displayed}
            {/* Blinking cursor while typing, steady space after */}
            <span className="login-status-cursor">|</span>
        </div>
    );
};

export default LoginStatus;
